import React from 'react';
import {ProspectPool} from 'api';
import {Popover} from 'components/antd';
import {getTagFontColor} from 'helpers/tagColors';
import {PlusSquare} from 'components/Ui/Icon';
import TagSelect from './TagSelect';
import useClientUser from 'hooks/useClientUser';

interface Props {
  prospectPool: ProspectPool;
}

export default ({prospectPool}: Props) => {
  const {isMember} = useClientUser();
  const [isPopoverVisible, setPopoverVisible] = React.useState(false);
  const prospectTags = prospectPool?.prospectTags || [];

  return (
    <div className="flex flex-wrap items-center gap-1 my-1">
      {prospectTags.length > 0 ? (
        prospectTags.map((tag) => (
          <span
            key={tag.id}
            className="flex px-1.5 py-0.5 rounded-sm"
            style={{
              backgroundColor: tag.color || 'black',
            }}
          >
            <span
              className="text-xs font-bold leading-4"
              style={{
                letterSpacing: '0.15px',
                color: getTagFontColor(tag.color),
              }}
            >
              {tag.name}
            </span>
          </span>
        ))
      ) : (
        <span>未設定</span>
      )}
      {isMember && (
        <Popover
          content={() => <TagSelect prospectPool={prospectPool} />}
          trigger="click"
          visible={isPopoverVisible}
          onVisibleChange={(visible) => setPopoverVisible(visible)}
          placement="bottomLeft"
        >
          <button
            className="cursor-pointer h-6 bg-transparent p-0"
            onClick={() => setPopoverVisible(true)}
          >
            <PlusSquare className="w-6 h-6" />
          </button>
        </Popover>
      )}
    </div>
  );
};
